export default __webpack_public_path__ + "static/media/Upload_Report_Icon.5c896dcb.svg";